<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">

          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.shop_id" placeholder="请选择校区" value-name="id" text-name="name" :data-func="$http.getShopList" />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.purchase_type" placeholder="请选择合约类型">
              <el-option v-for="(item) in puchaseTypeLists" :key="item.value+item.label" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.status" placeholder="请选择状态">
              <el-option v-for="(item) in noteStatusLists" :key="item.value+item.label" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="$refs['puchseauditlisttable'].fetchTableData() ">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchseauditlisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getAuditList">
        <el-table-column label="最后更新时间" prop="modify_time" align="center" />
        <el-table-column label="校区" prop="shop_name" align="center" />
        <el-table-column label="合约类型（批次号）" align="center">
          <template slot-scope="{row}">
            {{ row.purchase_type_name }} ({{ row.purchase_batch }})
          </template>
        </el-table-column>
        <el-table-column label="申请备注" prop="comment" align="center" />
        <el-table-column label="驳回理由" prop="apply_remark" align="center" />
        <el-table-column label="审核状态" prop="status_name" align="center" />
        <el-table-column label="操作" align="center" width="150px">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 20" type="primary" size="small" @click="fnAudit(row)">审核</el-button>
            <el-button v-if="row.status == 1" type="danger" size="small" @click="fnLock(row)">锁单</el-button>
          </template>
        </el-table-column>
      </wq-table>

    </div>
    <el-dialog
      title="采购详情"
      :visible.sync="dialogVisible1"
      custom-class="puchardetaildialog"
      center
      width="50%"
    >
      <wq-table ref="puchseauditgoodslisttable" :local-data="currentGoodsLists">
        <el-table-column label="物品名称" prop="goods_name" align="center" />
        <el-table-column label="申请数量 " prop="need_num" align="center" />
        <el-table-column label="图片" prop="purchase_num" align="center">
          <template slot-scope="{row}">
            <el-image v-if="row.photo" :src="row.photo" style="width: 40px;height: 40px;" width="20" height="20" />
          </template>
        </el-table-column>

      </wq-table>
    </el-dialog>
    <el-dialog
      title="采购详情"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-button type="text" text="" @click="dialogVisible1=true">查看采购商品>></el-button>
      <el-input v-model="currentAudit.comment" placeholder="驳回原因,审核成功无需填写" />
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="fnAudioSubmit('fail')">审核失败</el-button>
        <el-button type="success" @click="fnAudioSubmit('success')">审核成功</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>

import WqSelect from '@/components/FormBox/WqSelect'
import WqTable from '@/components/WqTable'
export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    WqSelect
  },

  data() {
    return {
      lists: [],
      listQuery: {
        shop_id: '',
        status: '20',
        purchase_type: ''
      },
      auditMessage: '',
      dialogVisible: false,
      dialogVisible1: false,
      currentAudit: {
        note_id: '',
        result: '',
        comment: ''
      },
      noteStatusLists: [],
      puchaseTypeLists: [],
      tableKey: 0,
      currentGoodsLists: []
    }
  },
  created() {
    this.fnGetSelctor()
  },
  methods: {
    fnGetSelctor() {
      this.$http.getAuditList().then((res) => {
        this.puchaseTypeLists = this.fnConvertObjectToArray(res.data.purchase_type)
        this.noteStatusLists = this.fnConvertObjectToArray(res.data.note_status)
      })
    },
    fnConvertObjectToArray(objs) {
      const ary = []
      for (const key in objs) {
        ary.push({ value: key, label: objs[key] })
      }
      return ary
    },
    fnInit() {
      this.$confirm('确定初始化吗？初始化后数据将会被还原，谨慎操作!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.shopPurchaseNoteSwitchInit().then((res) => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功!' })
          }
        })
      })
    },
    fnAudioSubmit(result) {
      console.log(result)
      if (result == 'fail' && this.currentAudit.comment == '') {
        this.$message({ type: 'warning', message: '请输入驳回原因!' })
        return
      }
      this.currentAudit.result = result
      this.$http.auditSubmit(this.currentAudit).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '审核结果提交成功!' })
          this.dialogVisible = false
          this.$refs['puchseauditlisttable'].fetchTableData()
        }
      })
    },
    fnAudit(result) {
      this.currentAudit.note_id = result.id
      this.currentGoodsLists = result.goods_list || []
      this.dialogVisible = true
      // this.$prompt('请输入审核备注', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPattern: /^.{1,200}$/,
      //   inputErrorMessage: '备注长度在1-200个字符之间'
      // }).then(({ value }) => {
      //   this.$http.adminAuditNote({
      //     note_id: row.id,
      //     remark: value
      //   }).then((res) => {
      //     if (res.code == 200) {
      //       this.$message({ type: 'success', message: '审核成功!' })
      //     }
      //   })
      // })
    },
    fnLock(row) {
      this.$confirm(`确定锁定"${row.purchase_type_name}(${row.purchase_batch})"吗？锁单后数据将无法修改，谨慎操作!`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.adminLockNote({
          note_id: row.id
        }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '锁单操作成功!' })
          }
        })
      })
    },
    fnSwich(id, switchs, type) {
      this.$http.setShopPurchaseNoteSwitch({
        shop_id: id,
        value: switchs[type],
        key: type
      }).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '操作成功!' })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.puchardetaildialog{
  .el-dialog__body {
    height: 500px;
    overflow-y: scroll;
  }
}
</style>

